import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonService } from 'src/app/services';
import { CommonStore } from 'src/app/store';

@Component({
  selector: 'app-printer-config',
  templateUrl: './printer-config.component.html'
})
export class PrinterConfigComponent implements OnInit {

    totalPrintSets: any;
    filteredPrintsets: any;
    DefaultLabelForm: FormGroup;

    @ViewChild("PrinterConfig", { static: true })
    PrinterConfig: any;
    selectedPrintset: any;
    optedPrintset: any;
    modalRef: any;
    unsubscribe$: Subject<void> = new Subject();

    @Output()
    IsPopUpClosed = new EventEmitter<any>();
    printerList: any;
    selectedDefaultPrinter: any;
    selectedReportPrinter: any;
    selectedReceiveMode: any;
    recvModeList: { Id: string; Name: string; }[];
    licenseDecryptValue = this._commonSvc.DecryptData(localStorage.getItem('SfaxEncryptionVector'));
    actvList: any;

    constructor(
        private _commonSvc: CommonService,
        private _modalService: NgbModal,
        private _cmnstr: CommonStore
    ) { 
        this.recvModeList = [{Id: 'B', Name: 'Buffer Mode'}, {Id: 'I', Name: 'Immediate Mode'}]
    }

    ngOnInit() {
        const InterfaceSet = this._cmnstr.interfacePharmConfigSetting$["source"]["value"];
        const configDet = InterfaceSet && InterfaceSet.length ? InterfaceSet[0].configurationDetail : null;
        this.actvList = configDet && configDet.sendData && configDet.sendData.length ? configDet.sendData.filter((item: any) => item.active) : null;
        this._cmnstr.allPrinters$
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(resp => {
            if (resp) {
                this.printerList = resp.map((name, index) => ({
                    Id: index,
                    Name: name
                }));
                if (this.printerList && this.printerList.length) {
                    this.checkForDefaultLabelPrinter();
                }
            }
        });
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    checkForDefaultLabelPrinter() {
        if (this.printerList && this.printerList.length) {
            if (localStorage.getItem("DefaultLabelPrinter")) {
                let defLabPrinter = localStorage.getItem("DefaultLabelPrinter");
                defLabPrinter = this.printerList.find(p => p?.Name === defLabPrinter)?.Id;
                if (this.printerList.find(elm => elm?.Id === defLabPrinter)) {
                    this.selectedDefaultPrinter = defLabPrinter;
                }
            }

            if (localStorage.getItem("DefaultReportPrinter")) {
                let defRepPrinter = localStorage.getItem("DefaultReportPrinter");
                defRepPrinter = this.printerList?.find(p => p?.Name === defRepPrinter)?.Id;
                if (this.printerList.find(elm => elm?.Id === defRepPrinter)) {
                    this.selectedReportPrinter = defRepPrinter;
                }
            }
            if (localStorage.getItem("DefaultReceiveMode")) {
                let defRecvMode = localStorage.getItem("DefaultReceiveMode");
                const selectedMode = this.recvModeList.find(elm => elm.Id === defRecvMode);
                this.selectedReceiveMode = selectedMode ? selectedMode.Id : null;
            }
            this.modalRef = this._modalService.open(this.PrinterConfig, { centered: true, keyboard: false, backdrop: false });
        }

    }

    optedInterfaceMode(eve) {
        if (eve) {
            this.selectedReceiveMode = eve.Id;
            localStorage.setItem("DefaultReceiveMode", eve.Id);
        } else {
            this.selectedReceiveMode = null;
            localStorage.removeItem("DefaultReceiveMode")
        }
    }

    optedPrinter(eve) {
        this.selectedDefaultPrinter = eve?.Id;
        if (eve) {
            localStorage.setItem("DefaultLabelPrinter", eve?.Name);
        } else {
            localStorage.removeItem("DefaultLabelPrinter")
        }
    }

    optedReportPrinter(eve) {
        this.selectedReportPrinter = eve?.Id;
        if (eve) {
            localStorage.setItem("DefaultReportPrinter", eve?.Name);
        } else {
            localStorage.removeItem("DefaultReportPrinter")
        }
    }

    closeModal() {
        if (this.modalRef) {
        this.modalRef.close();
        this.modalRef = null;
    }
        this.IsPopUpClosed.emit(true);
    }
}
